/**
 * Days — the weekdays the container runs, as seven toggles.
 * Weekend amount share stays saved but is hidden for now.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { CalendarDays } from 'lucide-react';
import { DROP_GEN_WEEKDAY_LABELS, DROP_GEN_WEEKDAYS, type DropGenWeekday, describeRunDays } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import type { ContainerEditor } from '../../../state/useContainerEditor';
import { CHOICE_CHIP, CHOICE_OFF, CHOICE_ON } from '../../controls/field-style';
import { StepRow, ValueLine } from '../../controls/StepRow';

export const DaysRow: FC<{ editor: ContainerEditor }> = ({ editor }) => {
  const { draft, setField } = editor;
  const days = draft.runDays;
  const toggle = (day: DropGenWeekday) =>
    setField('runDays', days.includes(day) ? days.filter((d) => d !== day) : DROP_GEN_WEEKDAYS.filter((d) => d === day || days.includes(d)));
  return (
    <StepRow
      icon={CalendarDays}
      label="Days"
      hint="Off days plan nothing. The weekday is the country's own day."
    >
      <div role="group" aria-label="Days it runs" className="flex flex-wrap items-center gap-1.5">
        {DROP_GEN_WEEKDAYS.map((day) => {
          const on = days.includes(day);
          return (
            <button
              key={day}
              type="button"
              aria-pressed={on}
              onClick={() => toggle(day)}
              className={cn(CHOICE_CHIP, 'min-w-11 justify-center px-2.5', on ? CHOICE_ON : CHOICE_OFF)}
            >
              {DROP_GEN_WEEKDAY_LABELS[day]}
            </button>
          );
        })}
      </div>
      <ValueLine key={days.join('')}>
        {days.length === 0 ? (
          <span className="text-xs font-medium text-warning">Pick at least one day.</span>
        ) : (
          <span className="text-xs text-muted-foreground">
            runs <b className="font-semibold text-foreground">{describeRunDays(days)}</b>
          </span>
        )}
      </ValueLine>
    </StepRow>
  );
};
